import {createAction, props} from '@ngrx/store';

export const trackRouteChange = createAction(
  '[Route Change] Track Google Analytics',
  props<{ payload: {ngRouterUrl: string; relativeUrl: string} }>()
);
